import { useContext, useEffect, useLayoutEffect, useState } from "react";

import { Navigate, Route, Routes, useNavigate, useLocation } from "react-router-dom";

import { ThemeProvider } from "styled-components";
import theme from "./styles/theme";

import { setConfiguration } from "react-grid-system";
import SignInPage from "./pages/SignInPage";
import BasicLayout from "./layouts/BasicLayout";
import { UserContext } from "./context/UserContext";
import SignOutPage from "./pages/SignOutPage";
import NotFoundPage from "./pages/NotFoundPage";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import ViewCompetencies from "./pages/Competencies/ViewCompetencies";
import QuestsPage from "./pages/Quest/Quests";
import axios from "axios";
import ViewCompetencyDetail from "./pages/Competencies/ViewCompetencyDetail";
import ModifyCompetency from "./pages/Competencies/ModifyCompetency";
import ModifyCompetencyDetail from "./pages/Competencies/ModifyCompetencyDetail";
import CreateCompetency from "./pages/Competencies/CreateCompetency";
import CreatePillar from "./pages/Pillars/CreatePillar";
import ViewPillars from "./pages/Pillars/ViewPillars";
import ModifyPillars from "./pages/Pillars/ModifyPillars";
import ModifyPillarDetail from "./pages/Pillars/ModifyPillarDetail";
import PillarSubdomains from "./pages/Pillars/PillarSubdomains";
import ModifySubdomainDetail from "./pages/Pillars/ModifySubdomainDetail";
import SubdomainKnowledgeAreas from "./pages/Pillars/SubdomainKnowledgeAreas";
import ModifyKnowledgeAreaDetail from "./pages/Pillars/ModifyKnowledgeAreaDetail";
import SubdomainKnowledgeTopics from "./pages/Pillars/SubdomainKnowledgeTopics";
import ModifyKnowledgeTopicDetail from "./pages/Pillars/ModifyKnowledgeTopicDetail";
import SelectVersion from "./pages/Curriculum/SelectVersion";
import { VersionContext } from "./context/VersionContext";
// import { SemesterPlan } from "./pages/SemesterPlan/SemeseterPlan";
import { Export_import } from "./pages/Export&Import/Export_import";
import BadGatewayPage from "./pages/BadGatewayPage";
import { UniversityPage } from "./pages/Universities/UniversityPage";

import { CompetencyAllVersion } from "./pages/CompetencyAllVersion/competencyAllVersion";

import { ModifyPillars1 } from "./pages/PillarsNew/ModifyPillars1";
import { PillarDoc } from "./pages/PillarDoc/PillarDoc";
import { ChangeHistory } from "./pages/ChangeHistory/ChangeHistory";
import { ProgramSelectModal } from "./components/ProgramSelectModal";
import { CurriculumDoc } from "./pages/CurriculumDoc/CurriculumDoc";

setConfiguration({
  gutterWidth: theme.spacing.base * 3,
  containerWidths: [540, 740, 960, 1140, 1200],
  breakpoints: [576, 768, 992, 1200, 1600],
});

const ProtectedRoute = ({
  isSignedIn,
  version,
  redirectPath = "/signin",
  children,
}: any) => {
  const location = useLocation();

  if (!isSignedIn) {
    return <Navigate to={redirectPath} replace />;
  }

  // If selected program or university not set, redirect to universities.
  if (
    (!localStorage.getItem("selectedProgram") ||
      !localStorage.getItem("university")) &&
    !location.pathname.includes("/universities")
  ) {
    return <Navigate to={"/universities"} replace />;
  }

  return children;
};
const UnprotectedRoute = ({
  isSignedIn,
  redirectPath = "/",
  children,
}: any) => {
  if (isSignedIn) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};
function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isSuperUser, setIsSuperUser] = useState(true);
  const userContext = useContext(UserContext);
  const versionContext = useContext(VersionContext);
  const navigate = useNavigate();
  let isTabClosed = false;

  window.addEventListener("beforeunload", function (event) {
    const currentTime = new Date().getTime();
    localStorage.setItem("appClosedTime", currentTime + "");
  });
  const appClosedTime = localStorage.getItem("appClosedTime");
  if (appClosedTime) {
    const currentTime = new Date().getTime();

    const timeDifference: any = currentTime - parseInt(appClosedTime);
    localStorage.setItem("difference", parseInt(timeDifference) + "");

    if (timeDifference > 1000) {
      // The app was closed and reopened within YOUR_THRESHOLD milliseconds
      localStorage.removeItem("selectedVersion");
    }

    // Clear the stored timestamp
    localStorage.removeItem("appClosedTime");
  }

  const selectedVersion = localStorage.getItem("selectedVersion");
  const initialVersion = JSON.parse(selectedVersion as string);
  useLayoutEffect(() => {
    setIsLoading(true);
    axios
      .get("/user")
      .then((res) => {
        if (res.data.user.id && res.data.user.roles) {
          const isDesigner = res.data.user.roles.find((v: any) => v.role === 3);
          const instructor = res.data.user.roles.find((v: any) => v.role === 2);

          const maxRole = res.data.user.roles.reduce((max: any, item: any) => {
            //finding the highest priority role in the array
            return item.role > max ? item.role : max;
          }, Number.MIN_SAFE_INTEGER);
          // const maxRoleId = res.data.user.roles.find(
          //   (
          //     v: any //finding ID of the highest priority role in the array
          //   ) => v.role === maxRole
          // ).role_id;

          const selectedVersion = localStorage.getItem("selectedVersion");
          const initialVersion = JSON.parse(selectedVersion as string);
          if (initialVersion && initialVersion?.university !== "") {
            versionContext.setCurrentVersion(initialVersion);
          }

          // if (maxRole && maxRole === 6) {
          //   getAdminIdentity(maxRoleId);
          // } else if (maxRole && maxRole === 2) {
          //   getInstructorIdentity(maxRoleId);
          // }
          if (!isDesigner && !instructor) {
            navigate("/unauthorized");
          }
          if (isDesigner?.active) {
            getDesignerIdentity(isDesigner.role_id);
          } else if (instructor?.active) {
            getInstructorIdentity(instructor.role_id);
          } else {
            navigate("/unauthorized");
          }
        }
      })
      .catch((err) => {
        if (
          err?.response?.status === 401 ||
          err?.response?.status === "401 Unauthorized"
        ) {
          navigate("/unauthorized");
        } else if (err?.response?.status === 502) {
          console.log("bad request error");
          navigate("/bad-gateway");
        } else if (err?.response?.status === 400) {
          // navigate("/unauthorized");
        } else {
          navigate("/signin");
        }
        setIsLoading(false);
      });
    const handleBackButton = (event: any) => {
      userContext.setModified(false);
      // Handle the back button action here
      // we can perform any necessary actions when the back button is pressed
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      // Clean up the event listener when the component unmounts
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);

  const getStudentIdentity = (stuId: string) => {
    setIsLoading(true);
    axios
      .get(`/student/identity?student_id=${stuId}`)
      .then((res) => {
        userContext.setCurrentUser({ role: "student", ...res.data.student });
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const getDesignerIdentity = (insId: string) => {
    axios
      .get(`/curriculum_designer/identity?curriculum_designer_id=${insId}`)
      .then((res) => {
        if (res.data.curriculum_designer) {
          if (
            window.location.pathname !== "/universities" &&
            window.location.pathname !== "/curriculum/version" &&
            window.location.pathname !== "/version-competency" &&
            versionContext.version &&
            versionContext.version.university === "" &&
            initialVersion?.version_number === 0
          ) {
            window.location.href = "/curriculum/version";
          }
          // setIsSuperUser(res.data.curriculum_designer.super_user);

          // if (!res.data.curriculum_designer.super_user) { ////////////////////////// >>>>>>>>>>>> note this line
          //   localStorage.setItem("university", res.data.curriculum_designer.university_code);
          // }
        }
        // if (res.data.curriculum_designer.university_code) {
        //   localStorage.setItem(
        //     "university",
        //     res.data.curriculum_designer.university_code
        //   );
        // }
        userContext.setCurrentUser({
          role: "curriculum_designer",
          ...res.data.curriculum_designer,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const getInstructorIdentity = (insId: string) => {
    axios
      .get(`/instructor/identity?instructor_id=${insId}`)
      .then((res) => {
        if (res.data.instructor.university_code) {
          localStorage.setItem(
            "university",
            res.data.instructor.university_code
          );
        }
        userContext.setCurrentUser({
          role: "instructor",
          ...res.data.instructor,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };
  const getAdminIdentity = (adminId: string) => {
    axios
      .get(`/admin/identity?admin_id=${adminId}`)
      .then((res) => {
        if (res.data.admin) {
          // setIsSuperUser(res.data.admin.super_user);
          if (!res.data.admin.super_user) {
            localStorage.setItem("university", res.data.admin.university_code);
          }
        }
        userContext.setCurrentUser({
          role: "admin",
          ...res.data.admin,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const [selectUniversityOpen, setSelectUniversityOpen] = useState(false);

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <BasicLayout
          isSuperUser={isSuperUser}
          setSelectUniversityOpen={setSelectUniversityOpen}
        >
          <ProgramSelectModal
            onSelect={() => {}}
            isOpen={selectUniversityOpen}
            setOpen={setSelectUniversityOpen}
          />
          <Routes>
            <Route path="/unauthorized" element={<UnauthorizedPage />} />

            {!isLoading && (
              <>
                <Route
                  path="/view/competencies"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <ViewCompetencies />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/universities"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <UniversityPage />
                    </ProtectedRoute>
                  }
                />
                {/* {isSuperUser && (
                  <Route
                    path="/universities"
                    element={
                      <ProtectedRoute
                        isSignedIn={userContext.isSignedIn}
                        version={versionContext.version}
                      >
                        
                        <UniversityPage />
                      </ProtectedRoute>
                    }
                  />
                )} */}
                <Route
                  path="/curriculum/version"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <SelectVersion isSuperUser={isSuperUser} />
                    </ProtectedRoute>
                  }
                />
                {/* <Route
                  path="/curriculum/export"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <Export_import />
                    </ProtectedRoute>
                  }
                /> */}
                <Route
                  path="/view/pillar/list"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <ViewPillars />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/modify/competency"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <ModifyCompetency />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/modify/pillar"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <ModifyPillars1 />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/modify/pillar/:pillarId"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <ModifyPillarDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/modify/pillar/:pillarId/subdomain"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <PillarSubdomains />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/modify/pillar/:pillarId/subdomain/:subdomainId"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <ModifySubdomainDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/modify/pillar/:pillarId/subdomain/:subdomainId/knowledge-area"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <SubdomainKnowledgeAreas />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/modify/pillar/:pillarId/subdomain/:subdomainId/knowledge-area/:knowledgeId"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <ModifyKnowledgeAreaDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/modify/pillar/:pillarId/subdomain/:subdomainId/knowledge-area/:knowledgeId/knowledge-topic"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <SubdomainKnowledgeTopics />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/modify/pillar/:pillarId/subdomain/:subdomainId/knowledge-area/:knowledgeId/knowledge-topic/:topicId"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <ModifyKnowledgeTopicDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/view/competency/detail/:competencyCode"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <ViewCompetencyDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/version-competency/view/competency/detail/:competencyCode/:identity_university/:identity_version"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <ViewCompetencyDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/modify/competency/:competencyCode"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <ModifyCompetencyDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/create/competency"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <CreateCompetency />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/create/pillar"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <CreatePillar />
                    </ProtectedRoute>
                  }
                />
                {/* <Route
                  path="/view/pillars/*"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <QuestsPage />
                    </ProtectedRoute>
                  }
                /> */}
                <Route path="/signout" element={<SignOutPage />} />
                <Route path="/oauth/login" />
                <Route
                  path="/signin"
                  element={
                    <UnprotectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <SignInPage />
                    </UnprotectedRoute>
                  }
                />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      {/* {isSuperUser ? (
                        <Navigate to={"/universities"} replace />
                      ) : ( */}
                      <Navigate to={"curriculum/version"} replace />
                      {/* )}{" "} */}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="*"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <NotFoundPage />
                    </ProtectedRoute>
                  }
                />
                {/* <Route
                  path="/semester-plan"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <SemesterPlan />
                    </ProtectedRoute>
                  }
                /> */}
                <Route
                  path="/version-competency"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <CompetencyAllVersion isSuperUser={isSuperUser} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/pillar-doc"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      {/* <PillarDoc /> */}
                      <CurriculumDoc/>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/change-history"
                  element={
                    <ProtectedRoute
                      isSignedIn={userContext.isSignedIn}
                      version={versionContext.version}
                    >
                      <ChangeHistory />
                    </ProtectedRoute>
                  }
                />
                <Route path="/bad-gateway" element={<BadGatewayPage />} />
              </>
            )}
          </Routes>
        </BasicLayout>
      </ThemeProvider>
    </div>
  );
}

export default App;
